import React from 'react';
export function NotebookMockup({
  color = 'blue',
  title = 'Módulo 1'
}: {
  color?: 'blue' | 'mint' | 'yellow' | 'lilac';
  title?: string;
}) {
  const colors = {
    blue: {
      bg: 'bg-pastel-blue',
      light: 'bg-pastel-blueLight',
      border: 'border-pastel-blue'
    },
    mint: {
      bg: 'bg-pastel-mint',
      light: 'bg-pastel-mintLight',
      border: 'border-pastel-mint'
    },
    yellow: {
      bg: 'bg-pastel-yellow',
      light: 'bg-pastel-yellowLight',
      border: 'border-pastel-yellow'
    },
    lilac: {
      bg: 'bg-pastel-lilac',
      light: 'bg-pastel-lilacLight',
      border: 'border-pastel-lilac'
    }
  };
  const theme = colors[color];
  return <div className="relative w-full aspect-[3/4] rounded-r-2xl rounded-l-md shadow-card bg-white border border-slate-100 overflow-hidden flex flex-col" data-id="element-110">
      {/* Binding */}
      <div className="absolute left-0 top-0 bottom-0 w-6 bg-slate-800 flex flex-col justify-evenly py-4 z-10" data-id="element-111">
        {[...Array(8)].map((_, i) => <div key={i} className="w-8 h-2 bg-slate-300 rounded-full -ml-1 shadow-sm" data-id="element-112" />)}
      </div>

      {/* Cover */}
      <div className={`ml-6 flex-1 ${theme.light} p-6 flex flex-col items-center justify-center text-center relative overflow-hidden`} data-id="element-113">
        <div className={`absolute -right-10 -top-10 w-32 h-32 rounded-full ${theme.bg} opacity-50`} data-id="element-114" />
        <div className={`absolute -left-10 -bottom-10 w-24 h-24 rounded-full ${theme.bg} opacity-50`} data-id="element-115" />

        <div className="relative z-10 w-full bg-white/80 backdrop-blur-sm p-4 rounded-xl shadow-sm border border-white" data-id="element-116">
          <h4 className="font-fredoka font-bold text-slate-800 text-lg mb-2" data-id="element-117">
            {title}
          </h4>
          <div className="w-12 h-1 bg-slate-200 mx-auto rounded-full mb-2" data-id="element-118" />
          <div className="w-8 h-1 bg-slate-200 mx-auto rounded-full" data-id="element-119" />
        </div>
      </div>
    </div>;
}